/**
 * Canonical SDK field projections shared across gift surfaces.
 *
 * Updated to the new contract shape — drops `depositPubkey`, `feePaid`,
 * `canWithdraw` (gone with the HandleVault model) and replaces them
 * with `giftPda`. The list fields now correspond 1·1 to the
 * `GetGiftsRow` codegen shape.
 */
export const GIFT_LIST_FIELDS = [
  'opaqueId',
  'giftPda',
  'recipientPlatform',
  'recipientHandle',
  'assetKind',
  'mintPubkey',
  'amount',
  'message',
  'anonymous',
  'status',
  'createdAt',
  'statusChangedAt',
  'senderHandle',
] as const;

/**
 * Permalink projection — flat shape, no contributors / vault / asset
 * nesting in the new contract.
 */
export const GIFT_PERMALINK_FIELDS = [
  'opaqueId',
  'giftPda',
  'senderProfileUrl',
  'recipientPlatform',
  'recipientHandle',
  'message',
  'createdAt',
  'status',
  'claimedAt',
  'canIndex',
  'viewerIsContributor',
  'assetKind',
  'amount',
  'mintPubkey',
  'sender',
] as const;

/**
 * Compat alias — kept so older callers compile. Identical to
 * `GIFT_PERMALINK_FIELDS` now (no contributors fold-in).
 */
export const GIFT_PERMALINK_WITH_CONTRIBUTORS_FIELDS: typeof GIFT_PERMALINK_FIELDS =
  GIFT_PERMALINK_FIELDS;
